//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import '../../assets/css/user.css'

export default {
  name: 'login',
  data() {
    return {
      submit_loading: false,
      user: {},
    }
  },
  created() {
    window._t = this;
  },
  methods: {
    on_submit: function () {

      if (!this.user.username || this.user.username.length < 4) {
        return this.$message('用户名过短,不少于4位', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }

      if (!this.user.password1 || this.user.password1.length < 6) {
        return this.$message('密码过短，不能少于6位', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }

      if (this.user.password1 != this.user.password2) {
        return this.$message('两次密码不相同', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }


      if (this.user.email.length < 3) {
        return this.$message('请输入正确的邮箱', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }

      this.submit_loading = true;

      var post_data = this.user;
      this.$axios.post('/app/user/register', post_data).then((response) => {
        this.submit_loading = false;
        var response_data = response.data;
        console.log("response_data:", response_data)
        var user_info = response_data.user_info;
        var token = response_data.token;
        this.$message('注册成功，正在跳转,如果没有跳转，你手动刷新页面。', {
          theme: "normal",
          position: "top-left",
          duration: 5000
        });

        this.$store.commit('login', {
          'userinfo':user_info,
          'token':token
        });
        this.$router.push('/');
      }).catch((error) => {
        this.submit_loading = false;
        this.$message('出现错误，请刷新网页或者稍后再试', {
          theme: "error",
        });
      });
      return false;
    }
  }

}
